import styled from "styled-components";
import { Container, Store, wrap, Wrapper } from 'AppReact';
import { SectionLabel } from './../../../common/atoms';
import {  AddSection } from '../../../common/molecules';
import device from "utils/device";
import { ContactsSection } from './emergencyContact'
import { switchLabel } from './../../../utilities';

const template = styled.div`
    width: 336px;
    padding: 0 24px;
    margin: 0 auto;

    @media ${device.tablet} {
        width: 594px;
    }
`


export const definition = {
    name: "EmergencyContact",
    props: { property: Store, emergencyContacts: Store, selectedTabId: Store, language: Store },
    elements: [
        {
            wrapper: Wrapper(template),
            name: "Wrapper",
            elements: [
                {
                    componentSelect: switchLabel,
                    name: 'SectionTitle',
                    displayValue: ({ language }) => `${language?.emergency_contacts || 'Emergency Contacts'}`,
                    bindings: ({ selectedTabId }) => selectedTabId,
                },
                {
                    component: ContactsSection,
                    isListOf: 'emergencyContacts',
                    name: 'ContactsList',
                    bindings: ({ language, emergencyContacts, emergencyContact, selectedTabId }) => ({ language, emergencyContacts, emergencyContact, onReview: selectedTabId == 'review'})
                },
                {
                    component: AddSection,
                    name: 'AddContact',
                    isButton: true,
                    renderIf: ({ selectedTabId }) => selectedTabId !== 'review',
                    bindings: ({ language, emergencyContacts }) => ({ emergencyContacts, label: `${language?.add_contact || 'Add Contact'}` }),
                },
            ]
        },
    ],
}

const EmergencyContact = Container(definition);

export default EmergencyContact;
